var exports = {
  "A": "menuButton__kpFdnV",
};

module.exports = exports;
